export default "__VITE_ASSET__DSOEIPjc__"